import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
  max-height: 86vh;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  color: var(--color-action-default);
  font-size: 20px;
  line-height: 24px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 4px;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--color-neutral-600);

  &:hover {
    color: var(--color-action-default);
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  color: var(--color-contrast-brand);
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
`;

export const TextInput = styled.input`
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid #aeb8c4;
  border-radius: 2px;
  color: var(--color-contrast-brand);
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: var(--color-action-default);
  }
`;

export const SectionTitle = styled.h3`
  margin: 4px 0 0;
  color: var(--color-action-default);
  font-size: 17px;
  line-height: 22px;
`;

export const PreviewWrapper = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  border-top: 1px dashed #aeb8c4;
  border-bottom: 1px solid #d6dce4;
`;

export const PreviewTable = styled.table`
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse;
  color: var(--color-contrast-brand);
  font-size: 12px;

  th,
  td {
    box-sizing: border-box;
    padding: 8px 6px;
    text-align: left;
    vertical-align: middle;
    border-bottom: 1px dashed #c8ced7;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
  }

  th {
    font-weight: var(--font-weight-semibold);
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }
`;

export const MaterialHeader = styled.th`
  box-sizing: border-box;
  width: 16%;
  max-width: 16%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MaterialCell = styled.td`
  box-sizing: border-box;
  width: 16%;
  max-width: 16%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PoReferenceInput = styled(TextInput)`
  width: 100%;
  min-width: 0;
  min-height: 34px;
  padding: 6px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 4px;

  button {
    width: auto;
    min-width: 140px;
    margin: 0;
  }
`;

export const ValidationMessage = styled.p`
  margin: 0;
  color: var(--color-feedback-danger-300);
  font-size: 13px;
`;
